import React from 'react'

const style = {
  width: 'calc(100% - 256px)',
  height: 'calc(100% - 80px)',
  marginLeft: 248,
  display: 'none',
  position: 'absolute',
  bottom: 8,
  border: '1px solid gray',
}

export function DRIframe({ showIframe, iframeRoom }) {
  return iframeRoom ? (
    <iframe
      title='Access Data Room'
      src={`/go/next?data_room=${iframeRoom}&no_margin=yes&no_logout=yes`}
      sandbox='allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads'
      style={{ ...style, display: showIframe ? 'block' : 'none' }}
    />
  ) : null
}
